import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { ChartModule } from '@ddt-web/chart';
import { SharedModule } from '@ddt-web/common';
import { CoreModule } from '@ddt-web/data-layer-components';
import { DataServiceModule } from '@ddt-web/data-service';
import { DcrModule } from '@ddt-web/dcr';
import { DisclosureModule } from '@ddt-web/disclosure';
import { GenericDirectivesModule } from '@ddt-web/generic-utils';

import { AlternativeDeepDiveComponent } from './components/alternative-deep-dive/alternative-deep-dive.component';
import { AssetAllocationProjectedRiskReturnComponent } from './components/asset-allocation-projected-risk-return';
import { CharacteristicInsightsComponent } from './components/common/characteristic-insights/characteristic-insights.component';
import { CharacteristicsTableComponent } from './components/common/characteristics-table/characteristics-table.component';
import { DecompositionTableComponent } from './components/common/decomposition-table/decomposition-table.component';
import { EquityDeepDiveComponent } from './components/equity-deep-dive/equity-deep-dive.component';
import { FiDeepDiveComponent } from './components/fi-deep-dive/fi-deep-dive.component';
import { MultiAssetDeepDiveComponent } from './components/multi-asset-deep-dive/multi-asset-deep-dive.component';
import { TotalRiskDecompositionComponent } from './components/total-risk-decomposition/total-risk-decomposition.component';

@NgModule({
	imports: [
		CommonModule,
		SharedModule,
		CoreModule,
		GenericDirectivesModule,
		ChartModule,
		DisclosureModule,
		DcrModule,
		CwpNgFrameworkModule,
		DataServiceModule
	],
	declarations: [
		MultiAssetDeepDiveComponent,
		AlternativeDeepDiveComponent,
		EquityDeepDiveComponent,
		FiDeepDiveComponent,
		DecompositionTableComponent,
		CharacteristicsTableComponent,
		CharacteristicInsightsComponent,
		TotalRiskDecompositionComponent,
		AssetAllocationProjectedRiskReturnComponent
	],
	exports: [
		EquityDeepDiveComponent,
		DecompositionTableComponent,
		CharacteristicsTableComponent,
		CharacteristicInsightsComponent,
		TotalRiskDecompositionComponent,
		FiDeepDiveComponent,
		MultiAssetDeepDiveComponent,
		AlternativeDeepDiveComponent,
		AssetAllocationProjectedRiskReturnComponent
	]
})
export class RiskModule { }
